import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NewsArticleDto, initializedNewsArticleDto } from '../shared/dto/news-article.dto';
import { SelectItem } from 'primeng/api';
import { NgForm } from '@angular/forms';
import { NewsArticleService } from '../shared/news-article.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { NotificationService } from 'src/app/shared';
import { ArticleTypeService } from '../shared/article-type.service';
import { ArticleTypeSearchDto } from '../shared/dto/article-type-search.dto';

@Component({
  selector: 'wl-news-article-edit-dialog',
  templateUrl: './news-article-edit-dialog.component.html',
  styleUrls: ['./news-article-edit-dialog.component.less'],
    standalone: false
})
export class NewsArticleEditDialogComponent implements OnInit {
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    this.showChange.emit(this._show);
  }
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @Output() saved: EventEmitter<void> = new EventEmitter();
  @ViewChild('editForm') editForm: NgForm;

  loading = false;
  isSaving = false;
  newsArticle: NewsArticleDto;
  articleTypeItems: SelectItem[] = [];
  showEditor = false;
  private _show: boolean;
  constructor(
    private _articleTypeService: ArticleTypeService,
    private _newsArticleService: NewsArticleService,
    private _notificationService: NotificationService
  ) {
    this.newsArticle = initializedNewsArticleDto();
  }

  ngOnInit(): void {
    this._articleTypeService.search(new ArticleTypeSearchDto()).then((data) => {
      this.articleTypeItems = data.Result.map<SelectItem>((x) => {
        return { label: x.ArticleType1, value: x.ArticleType1 };
      });
    });
  }

  public open(articleId: number) {
    if (articleId) {
      this.loading = true;
      this.newsArticle.ArticleId = articleId;
      this._newsArticleService
        .get(articleId)
        .then((data) => {
          this.newsArticle = data;
          this.showEditor = true;
        })
        .catch((err) => {
          this._notificationService.httpError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.newsArticle = initializedNewsArticleDto();
      this.showEditor = true;
    }
    this.show = true;
  }

  save() {
    this.isSaving = true;
    let promise: Promise<any>;

    if (this.newsArticle.ArticleId > 0) {
      promise = this._newsArticleService.update(this.newsArticle);
    } else {
      promise = this._newsArticleService.create(this.newsArticle);
    }
    promise
      .then((data) => {
        this._notificationService.translateSuccess('common.success');
        this.newsArticle = initializedNewsArticleDto();
        this.saved.emit();
        this.close();
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      })
      .finally(() => {
        this.isSaving = false;
        this.showEditor = false;
      });
  }

  close() {
    this.editForm?.form.markAsPristine();
    this.showEditor = false;
    this.show = false;
  }
}
